.sn-pricing-comparison {
  display: flex;
  flex-direction: column;
  gap: map-get($spacings, 2xl);

  &__header {
    display: flex;
    flex-direction: column;
  }


  &__table-wrapper {
    overflow: auto;
    border: 1px solid var(--border-color-secondary);
    border-radius: var(--radius-size-lg);
  }

  &__table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    min-width: 600px;
    table-layout: auto;

    @include above($breakpoint-desktop-md) {
      min-width: 980px;
    }
  }

  &__row {
    &:not(:last-child) .sn-pricing-comparison__cell {
      border-bottom: 1px solid var(--border-color-secondary);
    }

    &--header {
      .sn-pricing-comparison__cell {
        min-height: 76px;
      }
    }
  }

  &__cell {
    padding: map-get($spacings, md);
    font-weight: 400;
    font-size: map-get($font-sizes, sm);
    line-height: map-get($line-heights, md);
    color: var(--color-text-primary);
    text-align: center;
    vertical-align: middle;
    border-right: 1px solid var(--border-color-secondary);

    @include above($breakpoint-desktop) {
      padding: map-get($spacings, lg);
      font-size: map-get($font-sizes, md);
    }

    @include above($breakpoint-desktop-md) {
      padding: map-get($spacings, lg) map-get($spacings, xl);
    }

    &--header {
      font-weight: 700;
      font-size: map-get($font-sizes, md);
      line-height: map-get($line-heights, lg);
      padding: map-get($spacings, md);

      @include above($breakpoint-desktop) {
        font-size: map-get($font-sizes, lg);
        padding: map-get($spacings, lg);
      }

      @include above($breakpoint-desktop-md) {
        font-size: map-get($font-sizes, xl);
        padding: map-get($spacings, xl);
      }
    }

    &--label {
      text-align: left;
      font-weight: 400;
      color: var(--text-color-primary);
    }

    &--value {
      font-weight: 400;
    }

    &:last-child {
      border-right: 0;
    }
  }

  &__rating {
    display: inline-flex;
    align-items: center;
    gap: map-get($spacings, xs);
    font-size: map-get($font-sizes, md);
    line-height: map-get($line-heights, lg);

    @include above($breakpoint-desktop) {
      font-size: map-get($font-sizes, xl);
    }
  }

  &__star {
    color: var(--color-text-primary);
    flex-shrink: 0;
  }

  &__entry-price {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    gap: 0;
  }

  tbody tr:first-child .sn-pricing-comparison__cell {
    border-top: 1px solid var(--border-color-secondary);
  }

  tbody tr > td:nth-child(2),
  thead tr > th:nth-child(2) {
    background-color: var(--background-color-secondary);
  }

  .me-heading--4 {
    font-size: map-get($font-sizes, 2xl);

    @include above($breakpoint-desktop) {
      font-size: map-get($font-sizes, 3xl);
    }

    @include above($breakpoint-desktop-md) {
      font-size: map-get($font-sizes, 4xl);
    }
  }

  .me-heading--6 {
    font-size: 24px;
    line-height: 32px;
  }

  .me-text {
    font-size: map-get($font-sizes, md);
    line-height: map-get($line-heights, lg);

    @include above($breakpoint-desktop) {
      font-size: map-get($font-sizes, xl);
    }
  }
}
